import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// [超级提款机任务列表] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167772804
export const homepage = createAsyncThunk(
  '/live/misc/super_atm_mission_list',
  async (p: any, store: any) => {
    const resp = await http.post('/live/misc/super_atm_mission_list', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// [超级提款机领取任务] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167772827
export const mission_recevie = createAsyncThunk(
  '/live/misc/super_atm_mission_receive',
  async (p: {mission_id: number}, store: any) => {
    const resp = await http.post('/live/misc/super_atm_mission_receive', {
      ...p,
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)

// [任务去完成逻辑] http://wiki.xunlei.cn/pages/viewpage.action?pageId=167775383
export const super_atm_mission_goto = createAsyncThunk(
  '/live/misc/super_atm_mission_goto',
  async (p: {mission_id: number}, store: any) => {
    const resp = await http.post(
      '/live/misc/super_atm_mission_goto',
      {
        ...p,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const super_atm_sign = createAsyncThunk(
  'ATM/super_atm_sign',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/super_atm_sign',
      {
        ...p,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export const super_atm_sign_info = createAsyncThunk(
  'ATM/super_atm_sign_info',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/misc/super_atm_sign_info',
      {
        ...p,
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

export enum TaskStatus {
  未完成 = 0, // 未完成
  已完成 = 1, // 已完成
  完成可领取 = 2, // 可领取
}

export interface InitialStateType {
  currency_amount?: string
  cur_coins?: number
  max_coins?: number
  et?: number
  is_rich?: number // 0普通用户 1高价值用户
  has_prize?: boolean // 有抽奖获得的提现资格
  list?: {
    id: number // 任务ID
    name: string // 任务名称
    icon: string // 任务图标
    cur_score: number // 当前分数
    max_score: number // 最大分数
    status: TaskStatus // 任务状态
    jump: string // 任务跳转链接
    mission_type: number
  }[]
  fly_screen_list?: {
    name: string
    avatar: string
    content: string
  }[]
  toast?: string
  boost_card?: any
  sign_info?: any
}

const initialState: InitialStateType = {
  sign_info: {},
}

export const ATMSlice = createSlice({
  name: 'ATM',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(super_atm_sign_info.fulfilled, (state, action) => {
      Object.assign(state, {
        sign_info: action.payload,
      })
    })
  },
})
export default ATMSlice.reducer

export const useATMState = () => {
  const data = useSelector((state) => {
    return state.ATM
  })
  return data
}
